module.exports = __webpack_public_path__ + "img/vermicelli-statistics.24c78433.png";